﻿import DefaultApp from './defaultApp';

import BookItem from './components/BookItem.vue';

import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);
import { swiperConfig } from '../vendor/swiper';

const booksApp = {
    ...DefaultApp,
    components: {
        ...DefaultApp.components,
        BookItem,
    },
    data() {
        return {
            ...DefaultApp.data(),
            dataTopicLabel: '',
            dataSeriesLabel: '',

            swiper: null,
            activeSeries: null,
            seriesTitle: '',
            seriesDescription: '',
            seriesShow: false,
        }
    },
    computed: {
        ...DefaultApp.computed,
        seriesTypeSelected() {
            if (!this.facetsSet) return false;
            return this.data.facets.some(facet => facet.alias === this.constants.filterAliases.bookType && facet.values.some(option => option.valueAlias === this.constants.values.series));
        },
        filterItems() {
            if (this.dataOverruleIds.length && !this.itemsSet) {
                return [
                    {
                        Key: this.constants.filterAliases.id,
                        Values: this.dataOverruleIds,
                        Operator: this.constants.operators.in,
                    }
                ]
            }
            if (!this.facetsSet) return [];
            let facets = this.data.facets;
            if (!this.seriesTypeSelected) {
                this.activeSeries = null;
                facets = facets.filter(facet => facet.alias !== this.constants.filterAliases.seriesTitle);
            }
            return facets.filter(facet => facet.values.length).map(facet => {
                let values = facet.values.filter(option => option && option.valueAlias).map(option => option.valueAlias);
                return {
                    Key: facet.alias,
                    Values: values,
                    Operator: this.constants.operators.in,
                }
            });
        },
    },
    methods: {
        ...DefaultApp.methods,
        async init() {
            this.loading = true;

            if (this.$el.dataset.widget) this.dataWidget = this.$el.dataset.widget;
            if (this.$el.dataset.overruleids) this.dataOverruleIds = this.$el.dataset.overruleids.split(',');
            if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
            if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
            if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
            if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
            if (this.$el.dataset.topiclabel) this.dataTopicLabel = this.$el.dataset.topiclabel;
            if (this.$el.dataset.serieslabel) this.dataSeriesLabel = this.$el.dataset.serieslabel;

            const urlParams = new URLSearchParams(window.location.search);

            let pageParam = urlParams.has(this.constants.queryParams.page) ? parseInt(urlParams.get(this.constants.queryParams.page)) : 0;
            if (pageParam) urlParams.delete(this.constants.queryParams.page);
            this.searchText = urlParams.has(this.constants.queryParams.text) ? urlParams.get(this.constants.queryParams.text) : '';
            if (this.searchText) urlParams.delete(this.constants.queryParams.text);
            let filterParams = urlParams.toString() ? urlParams : null;
            if (filterParams) {
                const facetsResponse = await this.fetchData();
                this.setFacets(facetsResponse);
                this.setFacetValuesFromUrl();
                let seriesFacet = this.data.facets.find(facet => facet.alias === this.constants.filterAliases.seriesTitle);
                if (seriesFacet && seriesFacet.values && seriesFacet.values.length) this.activeSeries = seriesFacet.values[0];
            }

            if (this.dataOverruleIds.length) {
                const overruleResponse = await this.fetchData();
                if (overruleResponse && overruleResponse.data && overruleResponse.data.items && overruleResponse.data.items.length) {
                    overruleResponse.data.items = overruleResponse.data.items.sort((a, b) => this.dataOverruleIds.indexOf(a.id) - this.dataOverruleIds.indexOf(b.id));
                }
                this.setData(overruleResponse, true);
                this.dataOverruleIds = [];
            }

            let tempLimit = this.dataLimit;
            if (pageParam) {
                this.page = pageParam;
                this.dataLimit = this.dataLimit + (this.dataLimit * this.page);
            }

            const response = await this.fetchData();
            let replace = !this.itemsSet;
            this.setData(response, replace);
            this.dataLimit = tempLimit;

            if (this.itemsSet) {
                this.data.items = this.removeDuplicatesById(this.data.items);
                if (this.dataWidget) this.data.items = this.data.items.slice(0, this.dataLimit);
            }

            this.loading = false;
        },
        setFacets(response) {
            if (!response || response.status != 200 || !response.data.facets) return;
            this.data.facets = response.data.facets.sort((a, b) => a.sortOrder - b.sortOrder).map(facet => {
                let label = facet.alias;
                switch (facet.alias) {
                    case this.constants.filterAliases.topics:
                        label = this.dataTopicLabel;
                        break;
                    case this.constants.filterAliases.seriesTitle:
                        label = this.dataSeriesLabel;
                        break;
                    default:
                        break;
                }

                return {
                    ...facet,
                    values: facet.options.filter(option => option.selected),
                    label: label,
                }
            });
            this.data.queryCount = response.data.queryCount;
            if (this.dataSidebar) this.setFacetValuesFromUrl();
        },
        setData(response, replace = false) {
            if (!response || response.status != 200 || !response.data.items) return;
            if (!this.itemsSet || replace) {
                this.data.items = response.data.items;
            }
            else {
                response.data.items.forEach(item => {
                    this.data.items.push(item);
                })
            }
            this.setFacets(response);
            this.setSeriesData(response);
        },
        setSeriesData(response) {
            this.seriesTitle = response.data.seriesTitle;
            this.seriesDescription = response.data.seriesDescription;
            this.seriesShow = response.data.seriesShow;
        },
        updateUrl() {
            if (!this.queryModel.FilterItems.length && !this.page) {
                history.pushState({}, null, window.location.pathname);
                return;
            }
            const urlParams = new URLSearchParams();
            if (this.queryModel.Text) urlParams.set(this.constants.queryParams.text, this.queryModel.Text);
            if (this.queryModel.FilterItems.length) {
                this.queryModel.FilterItems.forEach(filterItem => {
                    let facet = this.data.facets.find(facet => facet.alias === filterItem.Key);
                    if (facet) urlParams.set(facet.title, filterItem.Values.join());
                });
            }
            if (this.page) urlParams.set(this.constants.queryParams.page, this.page);
            history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
        },
        toggleButton(facet, option) {
            if (!facet || !option) return;
            let dataFacet = this.data.facets.find(f => f.alias === facet.alias);
            let setOption = dataFacet.values.find(value => value.valueAlias === option.valueAlias);
            dataFacet.values = setOption ? [] : [option];
            this.fetchInitialData();
        },
        toggleSelect(facet) {
            if (!facet) return;
            let dataFacet = this.data.facets.find(f => f.alias === facet.alias);
            dataFacet.values = this.activeSeries ? [this.activeSeries] : [];
            this.fetchInitialData();
        },
        initSwiper() {
            this.swiper = new Swiper(this.$refs.swiper, {
                ...swiperConfig,
                spaceBetween: 24,
                breakpoints: {
                    ...swiperConfig.breakpoints,
                    1408: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    }
                }
            });
        },
    },
    updated() {
        if (this.dataWidget) this.initSwiper();
    },
};

export default booksApp;
